// path与name前缀
// const prefiexRoute = '/service/';
// const prefiexName = 'service';

export default [
  // 无优服务-产品介绍
  {
    path: '/service-happy-detail',
    redirect: '/service-happy-package',
    // component: () => import('@/views/service/happy/Detail.vue'),
    name: 'service.happy.detail',
    // meta: {
    //   title: 'CFMOTO 无忧服务介绍',
    //   auth: 0,
    // },
  },
  // 无优服务-订单确认
  {
    path: '/service-happy-order-confirm-:resourceId',
    component: () => import('@/views/service/happy/OrderConfirm.vue'),
    name: 'service.happy.order.confirm',
    meta: {
      title: '订单支付',
      auth: 0,
      backgroundClass: 'bg-happy-order-confirm',
    },
  },
  // 无优服务-订单支付结果
  {
    path: '/service-happy-order-result-:orderId',
    component: () => import('@/views/service/happy/OrderResult.vue'),
    name: 'service.happy.order.result',
    meta: {
      title: '支付结果',
      auth: 0,
      backgroundClass: 'bg-happy-order-result',
    },
  },
  // 无优服务-权益列表
  {
    path: '/service-happy-package',
    component: () => import('@/views/service/happy/Package.vue'),
    name: 'service.happy.package',
    meta: {
      title: '权益列表',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-happy-package/:serviceType',
    component: () => import('@/views/service/happy/Package.vue'),
    name: 'service.happy.package2',
    meta: {
      title: '权益列表',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 无优服务-权益列表
  {
    path: '/service-happy-package-detail-:resourceId',
    component: () => import('@/views/service/happy/PackageDetail.vue'),
    name: 'service.happy.package.detail',
    meta: {
      title: '权益详情',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 无优服务-我的权益
  {
    path: '/service-happy-rights',
    component: () => import('@/views/service/happy/Rights.vue'),
    name: 'service.happy.rights',
    meta: {
      title: '我的权益',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 无优服务-权益列表
  {
    path: '/service-happy-rights-detail-:orderId',
    component: () => import('@/views/service/happy/RightsDetail.vue'),
    name: 'service.happy.rights.detail',
    meta: {
      title: '权益详情',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 无优服务-权益记录
  {
    path: '/service-happy-rights-record-:vin',
    component: () => import('@/views/service/happy/RightsRecord.vue'),
    name: 'service.happy.rights.record',
    meta: {
      title: '权益使用记录',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 服务-在线报修
  {
    path: '/service-repair',
    component: () => import('@/views/service/repair/Index.vue'),
    name: 'service.repair',
    meta: {
      title: '报修记录',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-repair-create',
    component: () => import('@/views/service/repair/Create.vue'),
    name: 'service.repair.create',
    meta: {
      title: '在线报修',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-repair-result',
    component: () => import('@/views/service/repair/Result.vue'),
    name: 'service.repair.result',
    meta: {
      title: '报修申请',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 服务-自检手册
  {
    path: '/service-selfInspect',
    component: () => import('@/views/service/selfInspect/Index.vue'),
    name: 'service.selfInspect',
    meta: {
      title: '自检手册',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-selfInspect-list-:partId',
    component: () => import('@/views/service/selfInspect/List.vue'),
    name: 'service.selfInspect.list',
    meta: {
      title: '自检部件',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-selfInspect-detail-:id',
    component: () => import('@/views/service/selfInspect/Detail.vue'),
    name: 'service.selfInspect.detail',
    meta: {
      title: '自检详情',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 服务-失窃上报
  {
    path: '/service-lose-create',
    component: () => import('@/views/service/lose/Create.vue'),
    name: 'service.lose.create',
    meta: {
      title: '失窃上报',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 服务-使用指南
  {
    path: '/service-instruction',
    component: () => import('@/views/service/instruction/Index.vue'),
    name: 'service.instruction',
    meta: {
      title: '使用指南',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 服务-故障码查询
  {
    path: '/service-faultCode',
    component: () => import('@/views/service/faultCode/Index.vue'),
    name: 'service.faultCode',
    meta: {
      title: '故障码查询',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-faultCode-detail-:id',
    component: () => import('@/views/service/faultCode/Detail.vue'),
    name: 'service.faultCode-detaill',
    meta: {
      title: '故障码详情',
      auth: 0,
      backgroundClass: 'bg-gray',
    },
  },
  // 无优服务-道路救援告知书
  {
    path: '/service-happy-argumentRescue',
    component: () => import('@/views/service/happy/ArgumentRescue.vue'),
    name: 'service.happy.argumentRescue',
    meta: {
      title: '道路救援服务告知书',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
  // 实名认证
  {
    path: '/service-authentication-realname',
    component: () => import('@/views/service/authentication/Realname.vue'),
    name: 'service.authentication.realname',
    meta: {
      title: '实名认证',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
  // 三包
  {
    path: '/service-threeGuarantees-parts',
    component: () => import('@/views/service/threeGuarantees/Parts.vue'),
    name: 'service.threeGuarantees.parts',
    meta: {
      title: '配件价格',
      auth: 1,
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/service-threeGuarantees-policy',
    component: () => import('@/views/service/threeGuarantees/Policy.vue'),
    name: 'service.threeGuarantees.policy',
    meta: {
      title: '三包政策',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/service-threeGuarantees-policyPedal',
    component: () => import('@/views/service/threeGuarantees/PolicyPedal.vue'),
    name: 'service.threeGuarantees.policyPedal',
    meta: {
      title: '三包政策',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/service-threeGuarantees-policyNewEnergy',
    component: () => import('@/views/service/threeGuarantees/PolicyNewEnergy.vue'),
    name: 'service.threeGuarantees.policyNewEnergy',
    meta: {
      title: '三包政策',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
  // 智能体
  {
    path: '/service-cozeService-previewer-:botId-:token',
    component: () => import('@/views/service/cozeService/Previewer.vue'),
    name: 'service.cozeService.previewer',
    meta: {
      title: 'COZE预览',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
];
